import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, useNavigate, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_position_entry_hire = () => {
  useAuthRedirect();
  const { sno } = useParams();

  const navigate = useNavigate();
  const userId = localStorage.getItem("username");
   const [ownclosing, setOwnClosing] = useState({});
  const [formData, setFormData] = useState({
    vehicle_basis: "",
    driver: "",
  });


        const canEntry = hasPermission("Vehicle Closing List", "entry");
  

  
    useEffect(() => {
        const fetchOwnCLosing = async () => {
          if (!sno) return;
          try {
            const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/own_vehicle_closing_details?sno=${sno}`);
            if (response.data && response.data.closingOwn?.length > 0) {
                const items = response.data.closingOwn;

                const closingOwnDetail = {
                    vcode: items[0].vehicle_code,
                    vnumber: items[0].vehicle_number,
                    vname: items[0].vehicle_name,
                    vehicleBranch: items[0].branch_code,
                };

                setOwnClosing(closingOwnDetail);
                // console.log("Updated Header Details:", closingOwnDetail);
            } else {
                console.warn("API Response does not contain expected data structure");
            }
            
            
          } catch (error) {
            console.error("Error fetching locations:", error);
          }
        };
    
        fetchOwnCLosing();
      }, [sno]); 
    

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

   
    // Prepare payload
    const payload = {
        vcode: ownclosing.vcode,
        vehno: ownclosing.vnumber,
        vbranch: ownclosing.vehicleBranch,
        remarks: formData.remarks,
        vname: ownclosing.vname,
        user: userId,
        slNo: sno
      };
      
    console.log("Submitting Payload:", payload);

    try {
       Swal.fire({
                                              title: "Submitting...",
                                              text: "Please wait while we process your request.",
                                              allowOutsideClick: false,
                                              didOpen: () => {
                                                Swal.showLoading();
                                              },
                                            });
                
      const response = await axios.put(
        "https://rfs2.infraconsoft.net.in/api/own_closing_insert",
        payload
      );

     if (!response.data.success) {
             // Show error if bill is pending
             Swal.fire({
               icon: "error",
               title: "Cannot Close Vehicle",
               text: response.data.message,
             });
           } else {
             // Show success message
             Swal.fire({
               icon: "success",
               title: "Success",
               text: "Vehicle Closed successfully.",
               confirmButtonText: "OK",
             }).then(() => {
               navigate(`/own_vehicle_list`);
             });
           }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Submission failed. Please try again.");
    }
  };

  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
          <h2 className="add-txt">Own Vehicle Closing Form</h2>
          <Link to='/hire_vehicle_list'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
        </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="vcode" value={ownclosing.vcode} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="text" value={new Date().toLocaleDateString("en-GB")} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name :</label>
                <input type="text" name="vname" value={ownclosing.vname} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Number :</label>
                <input type="text" name="vehno" value={ownclosing.vnumber} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch Name :</label>
                <input type="text" name="branch" value={ownclosing.vehicleBranch} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Status :</label>
                <input type="text" name="driver" value="Own" onChange={handleChange}  readOnly={true} />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                  <label>Reason For Closing :</label>
                  <input type="text" name="remarks" value={formData.remarks} onChange={handleChange}  />
                </div>
              <div className="form-group">
                <label></label>
                <input type="hidden" />
              </div>
            </div>              
            <div className="btn-cls">
              <button type="submit" className="submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_position_entry_hire;
